module.exports = __webpack_public_path__ + "img/anemometer-DW-tile.77e2cd65.jpg";